<script setup lang="ts">
interface Props {
  html: string
  height: number
}
const props = defineProps<Props>()
const maxHeight = ref(`max-height: ${props.height}px; -webkit-mask-image: -webkit-gradient(linear,0% 50%,0% 100%,from(black),to(transparent)); mask-image: gradient(linear,0% 50%,0% 100%,from(black),to(transparent));`)
const moreButton = ref(true)
const load = () => {
  maxHeight.value = ''
  moreButton.value = false
}
</script>

<template>
  <div>
    <div v-html="html" :style="maxHeight" class="more overflow-hidden" />
    <div v-if="moreButton" class="flex justify-center items-center gap-[5px] md:hidden" @click="load()">
      <span class="text-12 underline">Czytaj więcej</span>
      <i class="icon-arrow-menu text-[10px] rotate-90" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@screen md {
  .more {
    @apply max-h-full #{!important};
    -webkit-mask-image: none !important;
    mask-image: none !important;
  }
}
</style>
